import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { buildConversationUrl, CONVERSATION_TAB_PARAM } from '@/entities/conversations';
import { CopyButton } from '@/shared/ui';

type Props = {
  dialogId: number;
  /** Вкладка детализации, открытая у копирующего; вкладка неизвестна — ссылка её не задаёт */
  tab?: string;
};

/**
 * Копирование ссылки на диалог для передачи другим пользователям.
 *
 * Ссылка собирается отдельно от адреса в строке браузера: тот несёт раздел, из которого диалог
 * открыт (закреплённый пресет, выборка), а этого раздела у получателя может не быть. Открытая
 * вкладка детализации, наоборот, в ссылку входит — диалогом делятся ради конкретного разбора.
 */
export const CopyDialogLinkButton: FC<Props> = ({ dialogId, tab }) => {
  const { t } = useTranslation('dialogs');

  return (
    <CopyButton
      text={buildConversationUrl(dialogId, { [CONVERSATION_TAB_PARAM]: tab })}
      tooltip={t('copyDialogLink')}
    />
  );
};
